import React from 'react';
import {
  Typography,
} from '@mui/material';
import {
  Info as InfoIcon,
  InsertDriveFile as InsertDriveFileIcon,
  People as PeopleIcon,
  Person as PersonIcon,
  PersonOutlined as PersonOutlinedIcon,
  RecentActors as RecentActorsIcon,
} from '@mui/icons-material';
import CardBase from 'components/CardBase';
import IconRow from 'components/IconRow';
import IconRowCell from 'components/IconRowCell';
import InlineDownloadButton from 'components/InlineDownloadButton';
import {
  CreateProcessRequestInput,
  FileData,
  ForeignNational,
  ProcessRequest,
  ProcessRequestEmployeeData,
  ProcessRequestEmployeeDataInput,
} from 'API';
import PersonService from 'services/person';
import { resolvers } from 'shared/enums';
import CardHeader from './CardHeader';

const { fullname } = PersonService;
interface Props {
  className?: string;
  national?:
  | ForeignNational
  | ProcessRequestEmployeeData
  | ProcessRequestEmployeeDataInput
  | null;
  process?: ProcessRequest | CreateProcessRequestInput;
  resume?: FileData;
}

const EmployeeInfoCard: React.FC<Props> = (
  {
    className, national, process, resume,
  }: Props,
) => {
  if (!national) {
    return null;
  }

  const resumeFile = (process as ProcessRequest)?.resume || resume;

  return (
    <CardBase className={className}>
      <CardHeader title="Employee Information" icon={PersonOutlinedIcon} />
      <IconRow>
        <IconRowCell type="icon">
          <InfoIcon color="action" />
        </IconRowCell>
        <IconRowCell type="text">
          <Typography variant="body2">PERSONAL INFORMATION</Typography>
          <Typography variant="caption" component="p">
            {national && fullname(national)}
          </Typography>
          {national?.email && (
            <Typography variant="caption" component="p">
              {national.email}
            </Typography>
          )}
        </IconRowCell>
      </IconRow>

      <IconRow>
        <IconRowCell type="icon">
          <PersonIcon color="action" />
        </IconRowCell>
        <IconRowCell type="text">
          <Typography variant="body2">SPOUSE</Typography>
          <Typography variant="caption" component="p">
            {national?.spouse && 'Yes'}
            {national?.spouse === false && 'No'}
            {national?.spouse == null && 'N/A'}
          </Typography>
        </IconRowCell>
      </IconRow>

      <IconRow>
        <IconRowCell type="icon">
          <PeopleIcon color="action" />
        </IconRowCell>
        <IconRowCell type="text">
          <Typography variant="body2">DEPENDENTS</Typography>
          <Typography variant="caption" component="p">
            {national?.dependents || 'N/A'}
          </Typography>
        </IconRowCell>
      </IconRow>

      {process && (
        <IconRow>
          <IconRowCell type="icon">
            <RecentActorsIcon color="action" />
          </IconRowCell>
          <IconRowCell type="text">
            <Typography variant="body2">PROCESS TYPE</Typography>
            <Typography variant="caption" component="p">
              {process.requestedProcess
                ? resolvers.VisaStatus(process.requestedProcess)
                : 'N/A'}
            </Typography>
          </IconRowCell>
        </IconRow>
      )}

      <IconRow>
        <IconRowCell type="icon">
          <InsertDriveFileIcon color="action" />
        </IconRowCell>
        <IconRowCell type="text">
          <Typography variant="body2">RESUME</Typography>

          {resumeFile
            ? (
              <Typography variant="caption" component="p" color="primary">
                <InlineDownloadButton
                  file={resumeFile}
                >
                  {resumeFile.fileName}
                </InlineDownloadButton>
              </Typography>
            )
            : (
              <Typography variant="caption" component="p">
                N/A
              </Typography>
            )}
        </IconRowCell>
      </IconRow>
    </CardBase>
  );
};

export default EmployeeInfoCard;
